import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ea41d7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = { class: "public-id__full" }
const _hoisted_3 = {
  key: 1,
  class: "public-id__full"
}
const _hoisted_4 = ["disabled", "title", "aria-label", "onClick"]
const _hoisted_5 = { key: 1 }

import { ref } from "vue";
import { DuplicateIcon } from "@heroicons/vue/outline";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";
import { compactPublicId } from "@/utils/publicId";


export default /*#__PURE__*/_defineComponent({
  props: {
  value: { type: String, default: "" },
  compact: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props

/* global defineProps */

const toast = useToast();
const copying = ref(false);

async function copy() {
  if (!props.value || copying.value) return;
  const value = props.value;
  copying.value = true;
  try {
    if (!navigator.clipboard?.writeText)
      throw new Error("Clipboard unavailable");
    await navigator.clipboard.writeText(value);
    toast.success(t("common.idCopied"));
  } catch {
    toast.error(t("common.idCopyFailed"));
  } finally {
    copying.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (__props.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "public-id",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        (__props.compact)
          ? (_openBlock(), _createElementBlock("details", {
              key: __props.value,
              class: "public-id__details"
            }, [
              _createElementVNode("summary", {
                title: __props.value,
                "aria-label": _unref(t)('common.showFullId')
              }, [
                _createElementVNode("code", null, _toDisplayString(_unref(compactPublicId)(__props.value)), 1)
              ], 8, _hoisted_1),
              _createElementVNode("code", _hoisted_2, _toDisplayString(__props.value), 1)
            ]))
          : (_openBlock(), _createElementBlock("code", _hoisted_3, _toDisplayString(__props.value), 1)),
        _createElementVNode("button", {
          type: "button",
          class: "public-id__copy",
          disabled: copying.value,
          title: _unref(t)('common.copyId'),
          "aria-label": _unref(t)('common.copyId'),
          onClick: _withModifiers(copy, ["stop"])
        }, [
          _createVNode(_unref(DuplicateIcon), {
            "aria-hidden": "true",
            class: "h-4 w-4"
          })
        ], 8, _hoisted_4)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_5, "—"))
}
}

})